import { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const propTypes = {
  onAddClick: PropTypes.func,
  placeholder: PropTypes.string,
};

function InputButton({ onAddClick, placeholder }) {
  const { t } = useTranslation();
  const [value, setValue] = useState("");
  return (
    <div className="flex items-center flex-wrap w-full relative">
      <input
        type="text"
        className="h-12 w-full border border-solid border-white relative rounded-md outline-none focus:border-white focus:text-white focus:outline-none focus:shadow-none pl-5 pr-2"
        onChange={(e) => {
          setValue(e.target.value);
        }}
        value={value}
        placeholder={placeholder}
      />

      <div className="absolute flex items-center justify-center top-0.5 bottom-0.5 right-1.5 p-2 z-10 bg-white">
        <button
          className="text-cyan text-base"
          onClick={() => {
            if (onAddClick()) {
              onAddClick(value);
              setValue("");
            }
          }}
        >
          {t("label__add")}
        </button>
      </div>
    </div>
  );
}

InputButton.propTypes = propTypes;
export default InputButton;
